export class Comments {
  constructor() {
    this.template = document.getElementById('message-template');
    this.editting = undefined;
    this.bindEvents();
  }

  bindEvents() {
    [...document.querySelectorAll('[data-edit-comment]')].forEach((element) => element.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggle(event.target.dataset.editComment);
    }));
    [...document.querySelectorAll('[data-delete-comment]')].forEach((element) => element.addEventListener('click', (event) => {
      event.preventDefault();
      this.deleteOrCancel(event.target);
    }));
  }

  toggle(id) {
    this.commentId = id;
    this.buttons = {
      // Double quotes break the selector
      edit: document.querySelector(`[data-edit-comment='${id}']`),
      delete: document.querySelector(`[data-delete-comment='${id}']`)
    };

    if (this.buttons.edit.innerText === 'Save') {
      this.buttons.edit.innerText = 'Edit';
      this.buttons.delete.innerText = 'Delete';
      this.save();
    } else {
      this.buttons.edit.innerText = 'Save';
      this.buttons.delete.innerText = 'Cancel';
      this.edit();
    }
  }

  edit() {
    this.editting = document.getElementById(`${this.commentId}-message`);
    this.originalValue = this.value = this.editting.innerHTML;
    this.editting.innerHTML = `<textarea id="comment-edit" name="message">${this.originalValue}</textarea>`;
    this.editor = $('#comment-edit').froalaEditor({
      key: window.FROALA_EDITOR_KEY,
      fileUploadURL: window.COMMENT_FILE_UPLOAD_URL,
      imageUploadURL: window.COMMENT_IMAGE_UPLOAD_URL,
      imageManagerLoadURL: window.COMMENT_IMAGE_MANAGER_LOAD_URL,
      imageManagerDeleteURL: window.COMMENT_IMAGE_MANAGER_DELETE_URL,
      imageManagerDeleteMethod: window.COMMENT_IMAGE_MANAGER_DELETE_METHOD,
      quickInsertButtons: [],
      placeholderText: '',
      pluginsEnabled: ['align', 'draggable', 'entities', 'file', 'image', 'imageManager', 'link', 'quickInsert', 'quote', 'table', 'url'],
      toolbarButtons: ['bold', 'italic', 'underline', '|', 'quote', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertFile', 'insertTable'],
      heightMin: 100
    });
    this.editor.on('froalaEditor.contentChanged', (e) => {
      this.value = e.target.value;
    });
  }

  save() {
    if (! this.value) {
      return this.delete(this.buttons.delete.form);
    }

    this.editor.off('froalaEditor.contentChanged');
    this.editor.froalaEditor('destroy');
    this.editting.innerHTML = this.value;

    if (this.value !== this.originalValue) {
      let input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'message');
      input.setAttribute('value', this.value);
      this.buttons.edit.parentNode.appendChild(input);
      this.buttons.edit.form.submit();
    }
  }

  cancel() {
    this.buttons.edit.innerText = 'Edit';
    this.buttons.delete.innerText = 'Delete';
    this.editor.off('froalaEditor.contentChanged');
    this.editor.froalaEditor('destroy');
    this.editting.innerHTML = this.originalValue;
  }

  deleteOrCancel(element) {
    if (element.innerText === 'Cancel') {
      return this.cancel();
    }

    this.delete(element.form);
  }

  delete(form) {
    if (confirm('Are you sure you want to delete your comment?')) {
      form.submit();
    }
  }
}
